import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { DatesProvider } from '@mantine/dates';
import '@mantine/notifications/styles.css';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import keycloak from './keycloak';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import GatewayPage from './pages/GatewayPage';
import SensorPage from './pages/SensorPage';
import ConnectPage from './pages/ConnectPage';
import UsersPage from './pages/UsersPage';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore - temporary: module resolution for DataPage.tsx triggers a false lint error
import DataPage from './pages/DataPage';
import SummaryPage from './pages/SummaryPage';
import MeasurementsPage from './pages/MeasurementsPage';
import AssetsPage from './pages/AssetsPage';
import CustomersPage from './pages/CustomersPage';
import SettingsPage from './pages/SettingsPage';
import PrivacyPage from './pages/PrivacyPage';
import ImprintPage from './pages/ImprintPage';
import TermsPage from './pages/TermsPage';
import LoginPage from './pages/LoginPage';
import HelpPage from './pages/HelpPage';
import DownloadsPage from './pages/DownloadsPage';
import AssetVersionHistoryPage from './pages/AssetVersionHistoryPage';
import UserAssetsPage from './pages/UserAssetsPage';
import { AppLayout } from './components/layout/AppLayout';
import './styles/index.scss';





function App(): React.JSX.Element {
  return (
    <ReactKeycloakProvider 
      authClient={keycloak} 
      initOptions={{
        onLoad: 'login-required',
        pkceMethod: 'S256',
        checkLoginIframe: false,
        flow: 'standard',
      }}
      onEvent={(event, error) => {
        console.log('Keycloak event:', event, error);
      }}
      onTokens={(tokens) => {
        console.log('Keycloak tokens received');
      }}
      LoadingComponent={<div>🔄 Keycloak wird initialisiert...</div>}
    >
      <AuthProvider>
        <MantineProvider defaultColorScheme="dark">
          <Notifications position="top-right" />
          <DatesProvider settings={{ locale: 'de', firstDayOfWeek: 1 }}>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/imprint" element={<ImprintPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/*" element={
                <ProtectedRoute>
                  <AppLayout>
                    <Routes>
                      <Route index element={<SummaryPage />} />
                      <Route path="gateway" element={<GatewayPage />} />
                      <Route path="sensor" element={<SensorPage />} />
                      <Route path="connect" element={<ConnectPage />} />
                      <Route path="admin/assets/:assetId/history" element={<AssetVersionHistoryPage />} />
                      <Route path="admin/assets" element={<ProtectedRoute requireAdmin><AssetsPage /></ProtectedRoute>} />
                      <Route path="admin/customers" element={<ProtectedRoute requireAdmin><CustomersPage /></ProtectedRoute>} />
                      <Route path="admin/users" element={<ProtectedRoute requireAdmin><UsersPage /></ProtectedRoute>} />
                      <Route path="data" element={<DataPage />} />
                      <Route path="measurements" element={<MeasurementsPage />} />
                      <Route path="assets" element={<UserAssetsPage />} />
                      <Route path="summary" element={<SummaryPage />} />
                      <Route path="settings" element={<SettingsPage />} />
                      <Route path="downloads" element={<DownloadsPage />} />
                      <Route path="help" element={<HelpPage />} />
                      <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                  </AppLayout>
                </ProtectedRoute>
              } />
            </Routes>
          </DatesProvider>
        </MantineProvider>
      </AuthProvider>
    </ReactKeycloakProvider>
  );
}

export default App;
